import IconButton from '@mui/material/IconButton';
import { AttachFile } from '@mui/icons-material';
import React from "react";
import Cloud from "../infra/Cloud.js";
import * as styleGlobal from "../infra/styleGlobal";
import { Text, View, OpenSnack, Progress } from "./index";

var host = "";
var token_api = "";
export default class SimpleFileUploader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      value: props.value
    };
    host = Cloud.getHost() + "/dashboard"
    token_api = Cloud.getToken();
  }


  componentDidUpdate(prevProps, prevState,) {

    if (prevProps.value != this.props.value) {
      this.setState({ value: this.props.value })
    }
  }


  directUpload(file) {
    this.setState({ load: true, });
    var url = host + "/anyfile";
    var data = new FormData();
    data.append("file", file);
    var config = {
      headers: {},
      method: "POST",
      contentType: false,
      processData: false,
      body: data
    };
    config.headers["x-request-id"] = token_api;
    config.headers["token-user"] = Cloud.getTokenUser();

    fetch(url, config)
      .then(response => {
        this.setState({ load: false });

        try {
          return response.json();
        } catch (e) {
          console.log(e);
          OpenSnack({ message: "Erro ao enviar menssagem: " + JSON.stringify(e), type: 'error' });
          return {};
        }
      })
      .then(data => {
        if (data) {
          if (this.props.callback) {
            data.nome = file.name;
            this.props.callback(data);
          }
        } else {
          this.setState({ value: "Erro..", });
        }
      })
      .catch(error => {
        OpenSnack({ message: "Erro ao enviar menssagem: " + JSON.stringify(error), type: 'error' });
        this.setState({ value: "Erro..", load: false });
      });
  }

  upLoadFile() {
    var file = document.createElement("INPUT");
    file.setAttribute("type", "file");
    file.style.visibility = "hidden";
    document.body.appendChild(file);
    file.click();
    file.addEventListener(
      "change",
      event => {
        var files = file.files;
        if (files && files[0]) {
          this.directUpload(files[0]);
        }
      },
      false
    );
  }



  render() {
    var { save, value, load } = this.state;
    var { children, multiple, icon, text = "" } = this.props;
    return (
      <IconButton style={{ alignSelf: 'center', }}
        onClick={() => {
          this.upLoadFile();
        }}>
        <Progress size={20} load={load}></Progress>
        {!load && <View style={{ color: styleGlobal.color1, alignItems: 'center' }}>
          {icon != null ?
            icon : <AttachFile style={{ color: styleGlobal.color1 }} />
          }
          {text ?
            <Text style={{ color: "black" }}>{text}</Text> : null
          }
        </View>}
      </IconButton>
    );
  }
}



var styles = {
  escolherarquivo: {
    marginRight: 0,
    marginTop: 30,
    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },

  inserireditartext: {
    textAlign: "center",
    alignSelf: "stretch",
    backgroundColor: "rgba(0,0,0,0)"
  },
  editar: {
    marginTop: 30,
    borderRadius: 5,

    backgroundColor: "#eee",
    padding: 5
  },
  cancelar: {
    flex: "none",
    width: 250,
    marginLeft: 10,
    alignSelf: "auto",

    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },
  deletar: {
    marginTop: 30,
    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },
  modal: {
    padding: 20,
    minWidth: 500,
  },
  someview: {
    borderStyle: "solid",
    borderColor: styleGlobal.color1,
    borderWidth: '0.25px',
    padding: 5,
    borderRadius: 5,
    flexDirection: "column",
    width: "auto"
  },
  labelsome: {
    shadowColor: "#000000",
    shadowOpacity: 0.99,
    shadowRadius: 5,
    alignSelf: "stretch",
    textAlign: "center",
    fontSize: 11,
    fontWeight: "500",
    shadowOffset: {
      height: 1,
      width: 1
    },
    color: "#000000",
    backgroundColor: "rgba(0,0,0,0)"
  },
  someview3: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 5,
    alignSelf: "stretch"
  },
  someview4: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
  },
  recortar: {
    flex: "none",
    width: 250,
    marginLeft: 10,
    alignSelf: "auto",

    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  }
};

